import script from "./tabr.vue?vue&type=script&setup=true&lang=js"
export * from "./tabr.vue?vue&type=script&setup=true&lang=js"

import "./tabr.vue?vue&type=style&index=0&id=19b09983&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19b09983"]])

export default __exports__